// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal
btn.onclick = function () {
  modal.style.display = "block";
};

// When the user clicks on <span> (x), close the modal
span.onclick = function () {
  modal.style.display = "none";
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

// Conversion starts

// Store the original inch values for all elements with class 'thesizes', ignoring empty ones
let originalInches = Array.from(document.querySelectorAll(".thesizes")).map(
  (div) => {
    let value = parseFloat(div.textContent);
    return isNaN(value) ? null : value; // Store null for empty divs
  }
);

// Function to convert inches to cm for all elements
function convertToCm() {
  document.querySelectorAll(".thesizes").forEach((div, index) => {
    let inchValue = originalInches[index];
    if (inchValue !== null) {
      // Only convert if the value is not null
      const cmValue = (inchValue * 2.54).toFixed(1); // Round to 1 decimal place
      div.textContent = cmValue;
      div.dataset.type = "cm"; // Mark the unit as cm
    }
  });
  setActiveButton("cmButton");
}

// Function to revert back to inches for all elements
function convertToInch() {
  document.querySelectorAll(".thesizes").forEach((div, index) => {
    let inchValue = originalInches[index];
    if (inchValue !== null) {
      // Only revert if the value is not null
      div.textContent = inchValue;
      div.dataset.type = "inches"; // Mark the unit as inches
    }
  });
  setActiveButton("inchButton");
}

// Function to set active button class
function setActiveButton(activeButtonId) {
  // Remove 'active' class from both buttons
  document.getElementById("cmButton").classList.remove("active");
  document.getElementById("inchButton").classList.remove("active");

  // Add 'active' class to the clicked button
  document.getElementById(activeButtonId).classList.add("active");
}
